import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { EventService } from "../../../../services/EventService";
import { EventDataDTO } from "../../../../models/event.model";
import { AddNote, Note } from "../../../../models/note.model";
import { OPTIONS_LOCALE_DATE } from "@/shared/constants/GeneralConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  EVENTS_ACCESS,
  EVENT_MESSAGES
} from "../../../../constants/EventConstants";
import { MODAL_DETAIL_CONSTANTS } from "../../constants/ModalDetailConstants";
import { AxiosError } from "axios";
import { Http } from "@status/codes";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";

Vue.use(Vuetify);
@Component({
  name: "DetailsContentDefault"
})
export default class DetailsContentDefault extends Vue {
  @Inject() eventService!: EventService;
  @Prop() eventData!: EventDataDTO;

  note = "";
  options = OPTIONS_LOCALE_DATE;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  MODAL_DETAIL_CONSTANTS = MODAL_DETAIL_CONSTANTS;
  UID = "UID";
  NOTES = "notes";
  SERVICE = "servicio";

  goToDetails(event: MouseEvent) {
    event.preventDefault();
    this.$emit("goToDetails");
  }

  async addNote() {
    try {
      const note: AddNote = {
        note: this.note,
        userId: localStorage.getItem(this.UID) ?? "",
        eventsTimeLineId: this.eventData.id as string
      };

      if (this.eventData.type == this.SERVICE) {
        note.serviceId = this.eventData.refId;
      }

      this.note = "";
      const noteRecord = await this.eventService.addNote(note);
      const copyEventNotesData = [...this.eventData.notes];
      copyEventNotesData.unshift((noteRecord.data as unknown) as Note);

      Vue.set(this.eventData, this.NOTES, copyEventNotesData);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + EVENTS_ACCESS.POST_NOTES
        );
      else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
    }
  }
}
